const CUSTOMER_URL = process.env.REACT_APP_CUSTOMER_URL;

export const CUSTOMER_DETAIL_URL = method => `${CUSTOMER_URL}?method=${method}`;
